import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { trackEvent } from '../../lib/meta-pixel'
import { useAuth } from '../../contexts/SupabaseAuthContext'
import AsaasCheckout from '../../components/payment/AsaasCheckout'
import { X } from 'lucide-react'

// Components
import Hero from './components/melhorador-desktop/Hero'
import Features from './components/melhorador-desktop/Features'
import Comparison from './components/melhorador-desktop/Comparison'
import Pricing from './components/melhorador-desktop/Pricing'

const MelhoradorPage = () => {
  const navigate = useNavigate()
  const { isAuthenticated } = useAuth()
  const [isCheckoutOpen, setIsCheckoutOpen] = useState(false)

  // Meta Pixel: ViewContent
  useEffect(() => {
    trackEvent('ViewContent', {
      content_name: 'Melhorador de Imagem',
      content_ids: ['melhorador'],
      content_type: 'product',
      value: 0,
      currency: 'BRL'
    })
  }, [])

  const handleSubscribe = () => {
    if (!isAuthenticated) {
      navigate('/auth/login')
      return
    }
    setIsCheckoutOpen(true)
  }

  return (
    <div className="min-h-screen bg-black text-white selection:bg-cyber-blue selection:text-black font-sans">

      {/* Checkout Modal */}
      {isCheckoutOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/90 backdrop-blur-md overflow-y-auto">
          <div
            className="relative bg-black w-full max-w-4xl rounded-2xl border border-cyber-blue/30 shadow-[0_0_50px_rgba(0,243,255,0.15)] overflow-hidden my-8 animate-in fade-in zoom-in duration-300"
            onClick={e => e.stopPropagation()}
          >
            {/* Blue Glow Background */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-20 bg-cyber-blue/10 blur-[50px] pointer-events-none"></div>

            <div className="absolute top-4 right-4 z-50">
              <button
                onClick={() => setIsCheckoutOpen(false)}
                className="bg-black/50 hover:bg-cyber-blue/20 text-gray-400 hover:text-cyber-blue p-2 rounded-full transition-all backdrop-blur-sm border border-transparent hover:border-cyber-blue/30 cursor-pointer"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            <div className="max-h-[90vh] overflow-y-auto custom-scrollbar relative z-10">
              <div className="p-6 md:p-8">
                <h2 className="text-3xl font-black text-transparent bg-clip-text bg-gradient-to-r from-cyber-blue via-white to-purple-500 mb-2 text-center drop-shadow-sm font-display">
                  Finalizar Compra
                </h2>
                <p className="text-gray-400 text-center mb-8">
                  Adquira sua licença anual e desbloqueie o poder máximo.
                </p>
                {/* 
                  Updated to use the new "blue" variant for consistent Cyber Blue theme
                */}
                <AsaasCheckout planKey="melhorador-annual" variant="blue" />
              </div>
            </div>
          </div>
        </div>
      )}

      <Hero />
      <Comparison />
      <Features />
      <Pricing
        onSubscribe={handleSubscribe}
        onLoginRequest={() => navigate('/auth/login')}
      />
    </div>
  )
}

export default MelhoradorPage
